/**
 *
 * OperationManagement
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 15-Jul-2024
 */

import { connect } from 'react-redux'
import OperationDetail from './OperationDetail'
import { bindActionCreators } from 'redux'
import { userPermissions } from 'Store/selectors'
import * as operationActions from 'Store/actions/operations'

const mapStateToProps = (state) => ({
  operation: state.operations?.operation || null,
  isLoading: state.loading?.local_OperationDetails || false,
  userPermissions: userPermissions(state),
  getSubscriptionArray: state?.user?.getSubscriptionArray || []
})

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(operationActions, dispatch),
  fetchOperationDetails: (operationId) => dispatch(operationActions.doFetchOperationDetails(operationId))
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationDetail)
